<template>
  <page-container>
    <heading size="gigantic">{{ $t("nav.myLinks") }}</heading>

    <b-message v-if="$utils.isEmpty(tagLinksGrouped)">
      You don't have any links.<br /><br />
      Richt-click (or click and hold on mobile) any tag and choose "share".<br />
      You can then create public Links to the selected tag and share it
      anywhere.<br />
      People don't need an account to view those links.
    </b-message>

    <div
      v-for="(group, tagId) in tagLinksGrouped"
      :key="`group-${tagId}`"
      class="mb4"
    >
      <div class="flex items-center mb3">
        <strong class="mr3 f3">Links for</strong>
        <tag-item
          style="margin-bottom: 0;"
          :tag="allTags[tagId]"
          @click="navigateToTag(allTags[tagId])"
          :context-options="{ userIsOwner: true, preventRemove: true }"
        ></tag-item>
      </div>

      <tag-link
        v-for="link in group"
        :key="`tag-link-${link.id}`"
        :link="link"
      ></tag-link>

      <hr class="divider" />
    </div>
  </page-container>
</template>

<script>
import TagItem from "@/shared/components/tag/Item.vue";
import TagLink from "@/shared/components/tag/Link.vue";

export default {
  components: {
    TagLink,
    TagItem
  },

  computed: {
    tagLinksGrouped() {
      return this.$store.getters.tagLinksGrouped;
    },
    allTags() {
      return this.$store.getters[`${this.currentContext}/tags`];
    }
  }
};
</script>

<style lang="scss" scoped>
.divider {
  background: $light_05;
  height: 1px;
}
</style>
